module.exports = __webpack_public_path__ + "img/kkb_colorinvader.47762a74.jpg";